import React from "react"

import styles from "./textText.module.scss"

const TextText = props => {
  return (
    <div className="module">
      <div className="wrapper">
        <div className="columns no-vertical-gap is-tablet is-0-mobile">
          <div className="column is-11-tablet is-offset-1-widescreen">
            <p className={`subhead ${styles.subhead}`}>{props.data.subhead}</p>
          </div>
        </div>
        <div className="columns no-vertical-gap is-tablet">
          <div className="column is-6-tablet is-5-widescreen is-offset-1-widescreen">
            <h2
              className={`h-3 h--cms-title ${styles.heading}`}
              dangerouslySetInnerHTML={{
                __html: props.data.heading,
              }}
            />
          </div>
          <div className="column is-6-tablet is-5-widescreen">
            <div
              className="user-content"
              dangerouslySetInnerHTML={{
                __html: props.data.body,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TextText
